import { Grid } from "@mui/material";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import Typography from "components/common/Typography";
import { tokens } from "styles/Tokens";

function Disclaimer(props: any) {
  const { open, setOpen } = props;

  return (
    <>
      <DialogFormation
        openDialog={open}
        title="Franchise Disclaimer"
        handleClose={() => setOpen(false)}
        actionConfig={
          <div className="modal-config-wrapper">
            <Button onClick={() => setOpen(false)} label={"Close"}></Button>
          </div>
        }
      >
        <Grid
          gap="16px"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start"
          }}
        >
          <Typography variant={"body1"} color={tokens.Text.General.PrimaryBody} textAlign="left">
            These confidential and proprietary materials are provided for informational purposes only, do not constitute
            legal or other professional advice and are an optional resource for Franchisees.
          </Typography>
          <Typography variant={"body1"} color={tokens.Text.General.PrimaryBody} textAlign="left">
            They are prepared for the benefit of Hilton managed hotels; Hilton makes no representation or warranty as to
            their accuracy or fitness for a particular purpose. Franchisees should consult with their own advisors
            before using them and may need to make modifications to reflect hotel specific circumstances, changes in
            environment and/or legal requirements. "Team Members" refers to employees of the Franchisee owner or
            management company, which is responsible for all hotel decisions, including, but not limited to, employment
            and pricing decisions. Hilton does not intend to exercise any direction, oversight, or control over
            Franchisee policies or procedures.
          </Typography>
        </Grid>
      </DialogFormation>
    </>
  );
}

export default Disclaimer;
